import React from 'react'
import { ConfirmationSummaryProps } from '../../CampaignModalSkeleton/CampaignModalSkeleton.types'
import { FixedAmountRuleState } from './types'
import {
	RuleSummaryArrow,
	RuleSummaryMechanicsRow,
	RuleSummaryStatBadge,
} from '../../CampaignModalSkeleton/components'

export function FixedAmountConfirmationSummary({
	rule,
}: ConfirmationSummaryProps<FixedAmountRuleState>) {
	return (
		<RuleSummaryMechanicsRow>
			<RuleSummaryStatBadge
				value={`${rule.threshold} €`}
				caption="panier minimum"
			/>
			<RuleSummaryArrow />
			<RuleSummaryStatBadge
				value={`${rule.discount} €`}
				caption="code promo débloqué"
			/>
		</RuleSummaryMechanicsRow>
	)
}
